import { useStore } from '~/plugins/store'

export function useSettings() {
  const store = useStore()
  return store.settings
}
